// extracted by mini-css-extract-plugin
export default {"headerContainer":"pageheader_headerContainer__YAVm1","homeLink":"pageheader_homeLink__VjkGC","cartIcon":"pageheader_cartIcon__PyXLU","cartCount":"pageheader_cartCount__ohIyG"};